import React from 'react';
import { Modal } from './Modal';
import { FiAlertTriangle } from 'react-icons/fi';
import './ConfirmDialog.css';

/**
 * Custom confirmation dialog (replaces window.confirm).
 * Styled to match application theme with Yes/No or OK/Cancel actions.
 */
export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Yes',
  cancelText = 'No',
  variant = 'danger', // 'danger' | 'warning' | 'primary' (icon + default confirm button)
  confirmButtonVariant, // optional: confirm button only (e.g. 'primary' while variant stays 'warning')
  showIcon = true,
  children,
  size = 'small',
  overlayClassName = '',
}) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  const confirmBtnVariant = confirmButtonVariant || variant;

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      className="confirm-dialog-modal"
      overlayClassName={overlayClassName}
      footer={
        <div className="confirm-dialog-footer">
          <button
            type="button"
            className={`btn btn-${confirmBtnVariant}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            {cancelText}
          </button>
        </div>
      }
    >
      <div
        className={
          children
            ? 'confirm-dialog-body confirm-dialog-body--stacked'
            : 'confirm-dialog-body'
        }
      >
        <div className="confirm-dialog-intro">
          {showIcon && (
            <div className={`confirm-dialog-icon confirm-dialog-icon-${variant}`}>
              <FiAlertTriangle size={28} />
            </div>
          )}
          {message ? (
            <p className="confirm-dialog-message">{message}</p>
          ) : (
            !children && (
              <p className="confirm-dialog-message">Are you sure you want to proceed?</p>
            )
          )}
        </div>
        {children}
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
